import { findNode } from "@/lib/tree/tree";
import { documentStore } from "@/store/store";
import { TreeNode } from "@/types/tree";

function isHoveringOverFutureLayerCanvasControlsAssociatedWithElement(element: HTMLElement): TreeNode | null {
  let current = element;
  
  while (current && current !== window.Breakdance.canvas.document.body) {
    if (current.hasAttribute('data-futurelayer-element-id')) {
      const elementId = current.getAttribute('data-futurelayer-element-id');
      if (elementId) {
        const node = findNode(documentStore.document.tree, elementId);
        return node ? node : null;
      }
    }
    current = current.parentElement as HTMLElement;
  }
  
  return null;
}

export function findNearestTreeNodeFromHTMLElement(element: HTMLElement): TreeNode | null {
  let current = element;
  
  const futureLayerControlNode = isHoveringOverFutureLayerCanvasControlsAssociatedWithElement(current);
  if (futureLayerControlNode) {
    return futureLayerControlNode;
  }
  
  while (current && current !== window.Breakdance.canvas.document.body) {
    if (current.hasAttribute('data-node-id')) {
      const nodeId = current.getAttribute('data-node-id');
      if (nodeId) {
        const node = findNode(documentStore.document.tree, nodeId);
        return node ? node : null;
      }
    }
    current = current.parentElement as HTMLElement;
  }
  
  return null;
}

